<loren-trace-dialog
  title="operations.choose_assets"
  subtitle="operations.choose_assets_sub_title"
  (continue)="continue()"
  >@if (formModel) {
  <loren-entity-form
    [formModel]="formModel"
    (formFieldInteraction)="handleFormInteractions($event)">
    </loren-entity-form
    >
  }</loren-trace-dialog>
